import React, { useCallback, useMemo } from "react";

import { IconRepasRounded } from "@routes/IconeSvg";
import _ from "lodash";
import { Controller } from "react-hook-form";

import ArhTimePicker from "@components/arhDatePicker/arhTimePicker";

const DEFAULT_TIME_VALUE = null;

const LunchHoursPicker = ({ control, formValidation, t, baseName = "" }) => {
  const getFormName = useCallback(
    (_inputName) => baseName + _inputName,
    [baseName]
  );
  const formNames = useMemo(
    () =>
      [
        "lunchStartDate",
        "lunchEndDate",
        "startLunchText",
        "endLunchText"
      ].reduce(
        (acc, _inputName) => ({
          ...acc,
          [_inputName]: getFormName(_inputName)
        }),
        {
          lunchStartDate: "lunchStartDate",
          lunchEndDate: "lunchEndDate",
          startLunchText: "startLunchText",
          endLunchText: "endLunchText"
        }
      ),
    [getFormName]
  );

  return (
    <div className="arh-relative arh-mt-3 arh-flex arh-justify-between">
      <div className="timeset_pauseRepas arh-text-xs">
        <div className="doubleTime_pauseRepas arh-flex arh-items-center arh-justify-between arh-space-x-8">
          {/* <div className="arhTimePicker_pauseRepas"> */}
          <div className="arh-relative arh-bg-transparent">
            <Controller
              control={control}
              name={formNames.lunchStartDate}
              defaultValue={DEFAULT_TIME_VALUE}
              rules={_.get(formValidation, formNames.lunchStartDate)}
              render={({
                field: { onChange, value },
                fieldState: { invalid }
              }) => (
                // @ts-ignore
                <ArhTimePicker
                  label={t("Début")}
                  selectedTime={value}
                  svgIcones={IconRepasRounded}
                  timeIntervals={15}
                  handleTimeChange={onChange}
                  invalid={invalid}
                  textName={formNames.startLunchText}
                  control={control}
                />
              )}
            />
          </div>
          {/* <div className="arhTimePicker_pauseRepas"> */}
          <div className="arh-relative arh-bg-transparent">
            <Controller
              control={control}
              name={formNames.lunchEndDate}
              defaultValue={DEFAULT_TIME_VALUE}
              rules={_.get(formValidation, formNames.lunchEndDate)}
              render={({
                field: { onChange, value },
                fieldState: { invalid }
              }) => (
                // @ts-ignore
                <ArhTimePicker
                  label={t("Fin")}
                  selectedTime={value}
                  svgIcones={IconRepasRounded}
                  timeIntervals={15}
                  handleTimeChange={onChange}
                  invalid={invalid}
                  textName={formNames.endLunchText}
                  control={control}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LunchHoursPicker;
